const generateUpdatedAt = () => Math.random();
import helpers from "@/helpers";
import api from "@/router/rotasAPI";
import axios from "@/libs/axios";

import { TIPONOTIFICACAO } from "@/custom-enum/tipo-notificacao.js";

const getRouteUpdateUserNotificationAsRead = (idNotificacaoUsuario) => {
    return helpers.preparaRotaComParametros(
        api.MinhasNotificacoesAtualizar,
        "{notificacaoUsuario}",
        idNotificacaoUsuario
    );
};

const consultaMinhasNotificacoes = (estado) => {
    axios.get(api.MinhasNotificacoesPendentes).then((res) => {
        estado.notifications.itens = res.status == 204 ? [] : res.data;
        estado.notifications.updated_at = generateUpdatedAt();
    });
};

const getNotificationsFiltered = (
    notifications,
    idTipoNotificacao = null,
    idTipoNotificacaoExclude = []

) => {

    let itens = Array.isArray(notifications.itens) ? notifications.itens : [];
    if (idTipoNotificacao != null) {
        itens = itens.filter(
            (notification) => notification.id_tipo_notificacao == idTipoNotificacao
        );
    }

    if (idTipoNotificacaoExclude.length > 0 && itens != null) {
        idTipoNotificacaoExclude.forEach((idNotificacao) => {
            itens = itens.filter(
                (notification) => notification.id_tipo_notificacao != idNotificacao
            );
        });
    }

    return {
        ...notifications,
        ... { itens },
    };
};

const state = {
    notifications: {
        user_id: null,
        colaborador_id:null,
        itens: [],
        updated_at: null,
    },
};

const mutations = {
    RESET_STATE(estado) {
        estado.notifications = {
            user_id: null,
            colaborador_id:null,
            itens: [],
        };
    },
    SET_UPDATED_AT(estado) {
        estado.notifications.updated_at = generateUpdatedAt();
    },
    SET_USER_ID(estado, user_id) {
        estado.notifications.user_id = user_id;
    },
    SET_COLABORADOR_ID(estado, colaborador_id) {
      estado.notifications.colaborador_id = colaborador_id;
    },
    SET_ITENS(estado, itens) {
        itens = typeof itens == 'object' && itens != null ? Object.values(itens) : itens;
               
        estado.notifications.itens = itens;
    },
    UPDATE_USER_NOTIFICATION_AS_READ(estado, idNotificacaoUsuario) {
        let route = getRouteUpdateUserNotificationAsRead(idNotificacaoUsuario);
        axios
            .put(route, {
                visualizada: true,
            })
            .then((_res) => {
                consultaMinhasNotificacoes(estado);
            });
    },
};

const actions = {
    resetState({ commit }) {
        commit("RESET_STATE");
        commit("SET_UPDATED_AT");
    },
    setUser({ commit }, {id_usuario, id_colaborador}) {
        commit("SET_USER_ID", id_usuario);
        commit("SET_COLABORADOR_ID", id_colaborador);
        commit("SET_ITENS", null);
        commit("SET_UPDATED_AT");
    },
    setItens({ commit }, itens) {
        commit("SET_ITENS", itens);
        commit("SET_UPDATED_AT");
    },
    async carregarNotificacoes({ commit }) {
        try {
            const res = await axios.get(api.MinhasNotificacoesPendentes);
            const itens = res.status === 204 ? [] : res.data;
            commit("SET_ITENS", itens);
            commit("SET_UPDATED_AT");
        } catch (e) {
            console.error('[carregarNotificacoes] ERRO:', e);
        }
    },

    async updateUserNotificationAsRead({ dispatch }, { idNotificacaoUsuario }) {
        const route = getRouteUpdateUserNotificationAsRead(idNotificacaoUsuario);
        await axios.put(route, { visualizada: true });
        await dispatch("carregarNotificacoes");
    },
};

const getters = {
    getUpdatedAt: (estado) => {
        return estado.notifications.updated_at;
    },
    getNotifications: (estado) => {
        return getNotificationsFiltered(estado.notifications);
    },
    getNotificationsImportacaoDePlanilha: (estado) => {
        return getNotificationsFiltered(
            estado.notifications,
            TIPONOTIFICACAO.IMPORTACAO_DE_PLANILHA
        );
    },
    getNotificationsBell: (estado) => {
        let notificacaoTipoModal = [
        ]
        return getNotificationsFiltered(estado.notifications, null, notificacaoTipoModal);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
